import { render, staticRenderFns } from "./MiddleAbout.vue?vue&type=template&id=d887219e&scoped=true&"
import script from "./MiddleAbout.vue?vue&type=script&lang=js&"
export * from "./MiddleAbout.vue?vue&type=script&lang=js&"
import style0 from "./MiddleAbout.vue?vue&type=style&index=0&id=d887219e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d887219e",
  null
  
)

export default component.exports